// extracted by mini-css-extract-plugin
export default {"tab-lists":"FAQLists_tab-lists__TXEU+","no-data-box":"FAQLists_no-data-box__dYF4c","img-box":"FAQLists_img-box__0NONA"};